// src/components/FilterChips.js
import React from 'react';
import '../styles/FilterChips.css';

const FilterChips = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div className="filter-chips">
      {categories.map(category => (
        <button
          key={category}
          className={`chip ${selectedCategory === category ? 'active' : ''}`}
          onClick={() => onCategoryChange(category)}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default FilterChips;